module.exports = __webpack_public_path__ + "static/img/nuvolos-layer-v13.69d784e1.svg";